export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5165.a6df5119.jpg";